import React, { ButtonHTMLAttributes } from "react";

import { Container, Loader } from "./styles";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  loading?: boolean;
  disabled?: boolean;
  action?: string;
  height?: string;
  fontSize?: string;
  fontWeight?: string;
};

export const Button: React.FC<ButtonProps> = ({
  children,
  loading,
  action,
  height,
  fontSize,
  fontWeight,
  ...rest
}) => {
  return (
    <Container action={action} height={height} fontSize={fontSize} fontWeight={fontWeight}>
      <button type="button" disabled={loading} {...rest}>
        {loading ? (
          <span arial-label="loading">
            <Loader />
          </span>
        ) : (
          children
        )}
      </button>
    </Container>
  );
};
